import { Row, Col } from "react-bootstrap";
import StatCard from "./StatCard";
import { KPI_CONFIG } from "../constants/kpiConfig";

export default function KpiSection({
  rekap,
  loading,
  icons,
  colors,
}) {
  return (
    <Row className="gx-3 gy-0">
      {KPI_CONFIG.map((item) => (
        <Col key={item.key} md={item.col || 4} sm={6}>
          <StatCard
            title={item.title}
            value={loading ? "…" : rekap[item.sourceKey || item.key] ?? 0}
            icon={icons[item.key]}
            {...colors[item.key]}
          />
        </Col>
      ))}
    </Row>
  );
}
